import { render, staticRenderFns } from "./alertDetails.vue?vue&type=template&id=f9289e38&scoped=true"
import script from "./alertDetails.vue?vue&type=script&lang=js"
export * from "./alertDetails.vue?vue&type=script&lang=js"
import style0 from "./alertDetails.vue?vue&type=style&index=0&id=f9289e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9289e38",
  null
  
)

export default component.exports